import withStickyBehavior from './withStickyBehavior';

import ConsumerHeader from './ConsumerHeader';

export default withStickyBehavior(ConsumerHeader);
